import { useCallback } from 'react';
import { zoneStrippedDateString } from '../../../../utilities/DateHelpers';
import { de } from 'date-fns/locale';

// Custom hook for adding treatment
export function useFormatAndSendFlagRequest(accountId, request, refreshAccount) {
  const onAddTreatment = useCallback(async (data) => {
    if(data.effectiveDate) {
      data.effectiveDate = zoneStrippedDateString((data.effectiveDate as Date));
    }
    if(data.expiryDate) {
      data.expiryDate =  zoneStrippedDateString((data.expiryDate as Date));
    }

    if(!data.numberOfBillingPeriods?.length) { 
      delete data.numberOfBillingPeriods;
    }

    await request({
      accountId,
      key: data.key,
      expiryDate: data.expiryDate,
    });
    refreshAccount();
  }, [accountId, request, refreshAccount]);

  return onAddTreatment;
}
